export default __webpack_public_path__ + "static/media/FirstSteps_3.182cfb0b.gif";